module.exports = __webpack_public_path__ + "static/media/porto-seguro-ba.b8f9af1d.jpg";